import { PropsWithChildren } from 'react';
import { attempt } from 'yoso';
import { useEvolveFormSecurity } from '~/components/Evolve/Form/Security/EvolveFormSecurity.hooks';
import { AdditionalNftModel } from '~/components/Membership/Membership.hooks';

type EvolveFormSecurityProps = PropsWithChildren<{
  tokenType: AdditionalNftModel['tokenType'];
}>;

export const EvolveFormSecurity = ({
  tokenType,
  children,
}: PropsWithChildren<EvolveFormSecurityProps>) => (
  <>{attempt(children, useEvolveFormSecurity(tokenType, { useErrorBoundary: true }))}</>
);
